/* Legacy "Our Food" page slider, ported from the old theme.
   Runs after DOMContentLoaded so the layout's deferred jQuery and Slick
   (apa-jquery.min.js, apa-slick.min.js) are guaranteed to have executed. */
(function () {
  function init() {
    if (!window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.slick !== 'function') return;
    var $ = window.jQuery;
    var $sliders = $('.Page_our_food_ingredients_slider').not('.slick-initialized');
    if (!$sliders.length) return;
    $sliders.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots:false,
      infinite: false,
      centerMode: false,
      prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="34" y="34" width="34" height="34" rx="17" transform="rotate(-180 34 34)" fill="#0C3D37"/><path d="M19.8333 22.6666L14.1667 17L19.8333 11.3333" stroke="white" stroke-width="3"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="34" y="34" width="34" height="34" rx="17" transform="rotate(-180 34 34)" fill="#0C3D37"/><path d="M19.8333 22.6666L14.1667 17L19.8333 11.3333" stroke="white" stroke-width="3"/></svg></button>',
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    });
  }
  // This file is deferred from the section, so it runs before the layout's
  // deferred jQuery/Slick (readyState is already 'interactive' by then).
  // Wait for DOMContentLoaded, which fires after every deferred script.
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init);
  }
  document.addEventListener('shopify:section:load', init);
})();
